export default "__VITE_ASSET__Bu0fXf0d__"